import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MarketingReveal from './MarketingReveal';
import { pageList, pageText } from '../../content/publicPages';
import { usePublicPage } from '../../hooks/usePublicPage';

/**
 * Peerspace “Your something starts somewhere” — lifestyle image + numbered props.
 */
const MarketingPossibilitiesBand = () => {
  const { saved, defaults } = usePublicPage('home');
  const steps = pageList(saved.why_steps, defaults.why_steps);
  return (
    <section className="bg-m-canvas-light px-4 py-20 sm:px-6 sm:py-28">
      <MarketingReveal className="mx-auto grid w-full max-w-6xl gap-12 lg:grid-cols-2 lg:items-center lg:gap-16">
        <div className="relative overflow-hidden rounded-[28px]">
          <img
            src={pageText(saved.why_image, defaults.why_image)}
            alt=""
            className="aspect-[4/5] w-full object-cover sm:aspect-[5/6]"
            loading="lazy"
          />
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/55 to-transparent p-6 sm:p-8">
            <p className="text-sm font-medium text-white">{pageText(saved.why_caption, defaults.why_caption)}</p>
            <p className="text-xs text-white/75">{pageText(saved.why_meta, defaults.why_meta)}</p>
          </div>
        </div>

        <div>
          <p className="mb-3 text-[11px] font-medium uppercase tracking-[0.14em] text-m-ink-faint">
            {pageText(saved.why_eyebrow, defaults.why_eyebrow)}
          </p>
          <h2 className="marketing-section-title mb-4 max-w-lg text-m-ink">
            {pageText(saved.why_title, defaults.why_title)}
          </h2>
          <p className="marketing-body-lg mb-10 max-w-md text-m-ink-muted">
            {pageText(saved.why_body, defaults.why_body)}
          </p>

          <div className="space-y-8">
            {steps.map((step) => (
              <div key={step.number} className="border-t border-m-border-light pt-6">
                <p className="mb-2 text-[11px] font-medium uppercase tracking-[0.14em] text-m-ink-faint">
                  {step.number}
                </p>
                <h3 className="mb-2 text-lg font-medium tracking-tight text-m-ink sm:text-xl">
                  {step.title}
                </h3>
                <p className="marketing-body text-m-ink-muted">{step.description}</p>
              </div>
            ))}
          </div>

          <div className="mt-10">
            <Link to="/how-it-works" className="marketing-btn marketing-btn-ink gap-2">
              See how booking works
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </MarketingReveal>
    </section>
  );
};

export default MarketingPossibilitiesBand;
